import get from "lodash/get";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { DfpComponent } from "../../ads/dfp-component";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

import "./bottom-ad.m.css";

export const BottomAd = () => {
  const [styles, setStyles] = useState({});
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adConfig = get(qtState, ["config", "ads-config", "slots", "bottom_sticky_ad"], {});
  const pageType = get(qtState, ["pageType"], null);

  const onClick = () => {
    setStyles({
      transform: "translate(0, 500vh)",
    });
  };

  return (
    <div styleName="wrapper" style={styles} className="bottom-ad-wrapper">
      <div onClick={onClick}>
        <SvgIconHandler
          iconStyle={{ color: "#000" }}
          className="close-icon"
          type="close"
          width="20"
          height="20"
          viewBox="0 0 12 12"
        />
      </div>
      <DfpComponent
        adStyleName="bottom-ad"
        id={`${pageType}-bottom-sticky-ad`}
        path={adConfig.ad_unit}
        size={adConfig.sizes}
        viewPortSizeMapping={adConfig.view_port_size_mapping}
      />
    </div>
  );
};
